import { useState } from "react";
import { Menu } from "lucide-react";
import { useAuth } from "@/App";
import NavLink from "./NavLink";
import DownloadAppButton from "./DownloadAppButton";
import MobileMenu from "./MobileMenu";
import UserMenu from "./UserMenu";

const LINKS = [
  { href: "#features", label: "Features" },
  { href: "#why-us", label: "Why Us?" },
  { href: "#pricing", label: "Pricing" },
  { href: "#team", label: "Team" },
  { href: "#faqs", label: "FAQ's" },
];

export default function TopNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();

  return (
    <>
      <header className="sticky top-3 z-30 px-3 sm:top-4 sm:px-4">
        <div className="mx-auto flex w-full max-w-3xl items-center justify-between gap-3 rounded-full bg-white/95 px-4 py-2 shadow-[0_8px_24px_rgba(15,23,42,0.06)] ring-1 ring-black/5 backdrop-blur sm:px-5">
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            aria-label="Shadow — back to top"
            className="flex shrink-0 items-center"
          >
            <img
              src="/images/landing-v2/hero/shadow-wordmark.svg"
              alt="SHADOW"
              className="h-3.5 w-auto sm:h-4"
            />
          </a>

          <nav className="hidden items-center gap-6 md:flex">
            {LINKS.map((link) => (
              <NavLink key={link.href} href={link.href}>
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <DownloadAppButton size="sm" location="nav" />
            {user && <UserMenu />}
          </div>

          <button
            type="button"
            aria-label="Open menu"
            onClick={() => setMobileOpen(true)}
            className="flex h-9 w-9 items-center justify-center rounded-full text-neutral-800 hover:bg-neutral-100 md:hidden"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>
      </header>

      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} links={LINKS} />
    </>
  );
}
